/**
 * @generated SignedSource<<9313c7b5dd46942759456d477354ac99>>
 * @relayHash 33e5168eba87d65c51aecc7637106f95
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a83167fc9eb0a34b2e657e939baa3a70fad4a61fad2df89323e909a82ec250e8

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectPanelQuery$variables = {
  ari: string;
  isProjectNativeIntegrationEnabled: boolean;
};
export type ProjectPanelQuery$data = {
  readonly me: {
    readonly user: {
      readonly accountId: string;
      readonly id: string;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
  };
  readonly projects_byId: {
    readonly canEditMembers: boolean | null | undefined;
    readonly contributors: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly userContributor: {
            readonly id: string;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly id: string;
    readonly owner: {
      readonly id: string;
    } | null | undefined;
    readonly url: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectActionsContent" | "ProjectContributesTo" | "ProjectContributors" | "ProjectFocusAreas" | "ProjectFollowers" | "ProjectJiraWork" | "ProjectLinks" | "ProjectOwner" | "ProjectPanelHeader" | "ProjectPanelTabs" | "ProjectStartDate" | "ProjectStatusField" | "ProjectTags" | "ProjectTargetDate" | "ProjectWorkTracked" | "RelatedProjects">;
  };
};
export type ProjectPanelQuery = {
  response: ProjectPanelQuery$data;
  variables: ProjectPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ari"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isProjectNativeIntegrationEnabled"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "picture"
},
v4 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v5 = [
  {
    "kind": "Variable",
    "name": "projectId",
    "variableName": "ari"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "url"
},
v7 = [
  (v1/*: any*/)
],
v8 = {
  "kind": "ScalarField",
  "name": "canEditMembers"
},
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = [
  (v9/*: any*/),
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
],
v11 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isUser"
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "AtlassianAccountUserExtendedProfile",
      "kind": "LinkedField",
      "name": "extendedProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jobTitle"
        }
      ]
    }
  ],
  "type": "AtlassianAccountUser"
},
v13 = {
  "kind": "ScalarField",
  "name": "count"
},
v14 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v15 = {
  "kind": "ScalarField",
  "name": "dark"
},
v16 = {
  "kind": "ScalarField",
  "name": "light"
},
v17 = {
  "kind": "ScalarField",
  "name": "description"
},
v18 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v19 = {
  "kind": "ScalarField",
  "name": "key"
},
v20 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v21 = [
  {
    "concreteType": "TownsquareLinkEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TownsquareLink",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v6/*: any*/),
          (v2/*: any*/)
        ]
      }
    ]
  },
  (v14/*: any*/)
],
v22 = [
  (v19/*: any*/),
  (v1/*: any*/)
],
v23 = {
  "kind": "InlineFragment",
  "selections": (v7/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v24 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v25 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v26 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                (v2/*: any*/),
                (v1/*: any*/),
                (v4/*: any*/),
                (v3/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v25/*: any*/),
            (v24/*: any*/)
          ]
        }
      ]
    },
    (v14/*: any*/)
  ]
},
v27 = {
  "kind": "ScalarField",
  "name": "summary"
},
v28 = [
  {
    "kind": "ScalarField",
    "name": "label"
  }
],
v29 = [
  (v9/*: any*/),
  (v3/*: any*/),
  (v2/*: any*/),
  (v1/*: any*/)
],
v30 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v27/*: any*/),
      (v17/*: any*/),
      {
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": (v29/*: any*/)
      },
      {
        "kind": "LinkedField",
        "name": "lastEditedBy",
        "plural": false,
        "selections": (v29/*: any*/)
      },
      (v24/*: any*/),
      {
        "kind": "ScalarField",
        "name": "lastEditedDate"
      }
    ],
    "type": "TownsquareHighlight",
    "abstractKey": "__isTownsquareHighlight"
  }
],
v31 = {
  "kind": "ScalarField",
  "name": "webUrl"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "RequiredField",
        "field": {
          "args": (v5/*: any*/),
          "concreteType": "TownsquareProject",
          "kind": "LinkedField",
          "name": "projects_byId",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v6/*: any*/),
            {
              "kind": "LinkedField",
              "name": "owner",
              "plural": false,
              "selections": (v7/*: any*/)
            },
            {
              "concreteType": "TownsquareContributorConnection",
              "kind": "LinkedField",
              "name": "contributors",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareContributorEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "concreteType": "TownsquareContributor",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "userContributor",
                          "plural": false,
                          "selections": (v7/*: any*/)
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            (v8/*: any*/),
            {
              "condition": "isProjectNativeIntegrationEnabled",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ProjectJiraWork"
                }
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectPanelHeader"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectTags"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectTargetDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectStatusField"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectOwner"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectLinks"
            },
            {
              "condition": "isProjectNativeIntegrationEnabled",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ProjectWorkTracked"
                }
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectFocusAreas"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectStartDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "RelatedProjects"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectContributesTo"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectContributors"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectFollowers"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectActionsContent"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectPanelTabs"
            }
          ]
        },
        "action": "THROW",
        "path": "projects_byId"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v5/*: any*/),
        "concreteType": "TownsquareProject",
        "kind": "LinkedField",
        "name": "projects_byId",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v6/*: any*/),
          {
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": (v10/*: any*/)
          },
          {
            "concreteType": "TownsquareContributorConnection",
            "kind": "LinkedField",
            "name": "contributors",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareContributorEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareContributor",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "userContributor",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v1/*: any*/),
                          (v4/*: any*/),
                          (v11/*: any*/),
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v12/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareTeamContributor",
                        "kind": "LinkedField",
                        "name": "teamContributor",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "contributingMembers",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v4/*: any*/),
                                      (v1/*: any*/),
                                      (v11/*: any*/),
                                      (v2/*: any*/),
                                      (v3/*: any*/),
                                      (v12/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v13/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TeamV2",
                            "kind": "LinkedField",
                            "name": "team",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "displayName"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "smallAvatarImageUrl"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "profileUrl"
                              },
                              {
                                "concreteType": "TeamMemberConnectionV2",
                                "kind": "LinkedField",
                                "name": "members",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TeamMemberEdgeV2",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TeamMemberV2",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "member",
                                            "plural": false,
                                            "selections": (v10/*: any*/)
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v14/*: any*/)
            ]
          },
          (v8/*: any*/),
          (v2/*: any*/),
          {
            "concreteType": "TownsquareWorkspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": (v7/*: any*/)
          },
          {
            "concreteType": "TownsquareIconURIs",
            "kind": "LinkedField",
            "name": "iconUrl",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareThemeURIs",
                "kind": "LinkedField",
                "name": "roundedSquare",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareTagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareTagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareTag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "usageCount"
                      },
                      (v17/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  }
                ]
              },
              (v14/*: any*/)
            ]
          },
          (v19/*: any*/),
          {
            "kind": "ScalarField",
            "name": "isArchived"
          },
          {
            "concreteType": "TownsquareProjectState",
            "kind": "LinkedField",
            "name": "state",
            "plural": false,
            "selections": (v20/*: any*/)
          },
          {
            "concreteType": "TownsquareTargetDate",
            "kind": "LinkedField",
            "name": "dueDate",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareTargetDateRange",
                "kind": "LinkedField",
                "name": "dateRange",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "start"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "end"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "confidence"
              }
            ]
          },
          {
            "concreteType": "TownsquareLinkConnection",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": (v21/*: any*/)
          },
          {
            "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseConnection",
            "kind": "LinkedField",
            "name": "focusAreas",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "uuid"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "userPermissions"
                          },
                          (v2/*: any*/),
                          (v6/*: any*/),
                          {
                            "concreteType": "MercuryFocusAreaStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": (v22/*: any*/)
                          },
                          {
                            "concreteType": "MercuryFocusAreaHealth",
                            "kind": "LinkedField",
                            "name": "health",
                            "plural": false,
                            "selections": (v22/*: any*/)
                          }
                        ],
                        "type": "MercuryFocusArea"
                      },
                      (v23/*: any*/)
                    ]
                  },
                  (v1/*: any*/)
                ]
              },
              (v14/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "startDate"
          },
          (v24/*: any*/),
          {
            "concreteType": "TownsquareProjectDependencyConnection",
            "kind": "LinkedField",
            "name": "dependencies",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectDependencyEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareProjectDependency",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "linkType"
                      },
                      {
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "incomingProject",
                        "plural": false,
                        "selections": (v7/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "outgoingProject",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v19/*: any*/),
                          (v2/*: any*/),
                          (v6/*: any*/),
                          {
                            "concreteType": "TownsquareIconURIs",
                            "kind": "LinkedField",
                            "name": "iconUrl",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareThemeURIs",
                                "kind": "LinkedField",
                                "name": "square",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/),
                                  (v15/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v14/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "goals",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v6/*: any*/),
                      (v2/*: any*/),
                      {
                        "concreteType": "TownsquareStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": (v20/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareGoalType",
                        "kind": "LinkedField",
                        "name": "goalType",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalTypeIcon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/)
                            ]
                          },
                          (v1/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v14/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareUserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "concreteType": "TownsquareUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v1/*: any*/),
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareProjectDescription",
            "kind": "LinkedField",
            "name": "description",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "what"
              },
              {
                "kind": "ScalarField",
                "name": "why"
              },
              {
                "kind": "ScalarField",
                "name": "measurement"
              }
            ]
          },
          (v26/*: any*/),
          {
            "concreteType": "TownsquareProjectUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareProjectUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "ari"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "missedUpdate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "updateType"
                      },
                      (v27/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v1/*: any*/),
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": (v28/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareProjectState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": (v20/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v4/*: any*/),
                          (v2/*: any*/),
                          (v1/*: any*/)
                        ]
                      },
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v6/*: any*/),
                      {
                        "concreteType": "TownsquareProjectState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v20/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v28/*: any*/)
                      },
                      (v26/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareProjectUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              (v14/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "watcherCount"
          },
          {
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareHighlightEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v1/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v30/*: any*/),
                        "type": "TownsquareLearning"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v30/*: any*/),
                        "type": "TownsquareRisk"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v30/*: any*/),
                        "type": "TownsquareDecision"
                      }
                    ]
                  }
                ]
              },
              (v14/*: any*/)
            ]
          },
          {
            "condition": "isProjectNativeIntegrationEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 5
                  }
                ],
                "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemConnection",
                "kind": "LinkedField",
                "name": "linkedJiraWorkItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v1/*: any*/),
                              (v31/*: any*/),
                              (v27/*: any*/),
                              {
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "permission",
                                    "value": "EDIT_ISSUES"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "hasProjectPermission",
                                "storageKey": "hasProjectPermission(permission:\"EDIT_ISSUES\")"
                              },
                              {
                                "concreteType": "JiraStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "statusId"
                                  },
                                  (v2/*: any*/),
                                  {
                                    "concreteType": "JiraStatusCategory",
                                    "kind": "LinkedField",
                                    "name": "statusCategory",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "statusCategoryId"
                                      },
                                      (v2/*: any*/),
                                      (v1/*: any*/)
                                    ]
                                  },
                                  (v1/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "issueTypeId"
                                  },
                                  (v2/*: any*/),
                                  (v1/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraIssue"
                          },
                          (v23/*: any*/)
                        ]
                      },
                      (v1/*: any*/)
                    ]
                  }
                ],
                "storageKey": "linkedJiraWorkItems(first:5)"
              }
            ]
          },
          {
            "condition": "isProjectNativeIntegrationEnabled",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": "workTrackingLinks",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  },
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "WORK_TRACKING"
                  }
                ],
                "concreteType": "TownsquareLinkConnection",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": (v21/*: any*/),
                "storageKey": "links(first:1,type:\"WORK_TRACKING\")"
              },
              {
                "concreteType": "TownsquareFusionDetails",
                "kind": "LinkedField",
                "name": "fusion",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "synced"
                  },
                  {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "issue",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v19/*: any*/),
                      (v31/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a83167fc9eb0a34b2e657e939baa3a70fad4a61fad2df89323e909a82ec250e8",
    "metadata": {},
    "name": "ProjectPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "743a3b9dd06694a5084566aaea102d37";

export default node;
